import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            热门话题标签
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            当前最受关注的黑料吃瓜话题，点击探索更多相关内容
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item, idx) => (
            <div
              key={idx}
              className="group flex items-center gap-3 px-4 py-3 bg-background-50 border border-background-200 rounded-lg hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span
                className={`px-1.5 py-0.5 text-xs font-medium rounded whitespace-nowrap ${
                  item.hot === '爆'
                    ? 'bg-primary-500 text-white'
                    : item.hot === '热'
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-secondary-200 text-secondary-700'
                }`}
              >
                {item.hot}
              </span>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}讨论</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}